import { useRef, useEffect, useCallback } from 'react'

const useResizeObserver = ({ callback, element, isLazy = false }) => {
  const mounted = useRef(null)
  const observer = useRef(null)
  const started = useRef(false)
  const elementRef = useRef(null)

  useEffect(() => {
    mounted.current = true

    return () => {
      mounted.current = false
    }
  }, [])

  const createObserver = useCallback((createCallback, createElement = null) => {
    elementRef.current = createElement
    observer.current = new ResizeObserver(() => {
      if (!started.current) {
        started.current = true
        return
      }

      if (mounted.current) {
        createCallback()
      }
    })

    if (elementRef.current) {
      observer.current.observe(elementRef.current)
    }
  }, [])

  const destroyObserver = useCallback(() => {
    if (elementRef.current) {
      observer.current.unobserve(elementRef.current)
    }
  }, [])

  useEffect(() => {
    if (!isLazy) {
      createObserver(callback, element)
    }

    return () => {
      if (!isLazy) {
        destroyObserver()
      }
    }
  }, [callback, element])

  return {
    createObserver,
    destroyObserver
  }
}

export default useResizeObserver
